import React from "react";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import i18n from "../../../constants/i18n";
import UserRateUsForm from "./user-rate-us-form";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import UserRateUsData from "./user-rate-us-data";

const UserRateUs = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "AUDITOR_USER_RATE_US_DATA",
      "AUDITOR_USER_RATE_US_DATA"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER_RATE_US_DATA")}
        subTitle={i18n.get("USER_RATE_US_DATA")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <UserRateUsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserRateUsData />
    </ET3PageDiv>
  );
});
export default UserRateUs;
